import { values } from 'lodash'
export const LOOKING_FOR_WORK = 'LOOKING_FOR_WORK'
export const BETWEEN_ARMY_AND_SCHOOL = 'BETWEEN_ARMY_AND_SCHOOL'
export const SKILLED_NO_EXPERIENCE = 'SKILLED_NO_EXPERIENCE'
export const CHANGING_PROFESSION = 'CHANGING_PROFESSION'
export const FUMBLING = 'FUMBLING'
export const HITECH = 'HITECH'
export const SEARCH = 'SEARCH'
export const COMPLETE = 'COMPLETE'
export const RESPONSE = 'RESPONSE'

export const wizardNames = {
    LOOKING_FOR_WORK, // nextjobdata
    BETWEEN_ARMY_AND_SCHOOL,
    SKILLED_NO_EXPERIENCE,
    FUMBLING,
    HITECH,
    COMPLETE,
    RESPONSE
}

export const API = {
    [LOOKING_FOR_WORK]: `${process.env.baseUrl}api/wizard/nextjobdata`,
    [BETWEEN_ARMY_AND_SCHOOL]: `${process.env.baseUrl}api/wizard/afterarmydata`,
    [SKILLED_NO_EXPERIENCE]: `${process.env.baseUrl}api/wizard/noexperiencedata`,
    [FUMBLING]: `${process.env.baseUrl}api/wizard/fumblingdata`,
    [HITECH]: `${process.env.baseUrl}api/wizard/hitechdata`,
    [SEARCH]: `${process.env.baseUrl}api/wizard/search`
}

export const HITECH_CATEGORIES = new Array(
        4,
        5,
        6,
        24,
        28,
        30,
        38,
        40,
        41,
        43,
        44,
        45,
        46,
        48,
        49,
        50,
        51,
        184,
        191,
        257,
        371,
        381,
        405,
        478,
        520,
        52,
        53,
        54,
        56,
        57,
        59,
        60,
        61,
        62,
        173,
        209,
        227,
        228,
        231,
        235,
        236,
        242,
        249,
        270,
        324,
        392,
        400,
        407,
        436,
        469,
        474,
        491,
        546,
        581,
        64,
        65,
        66,
        68,
        69,
        70,
        72,
        73,
        75,
        175,
        183,
        240,
        245,
        246,
        255,
        259,
        315,
        316,
        372,
        380,
        406,
        460,
        465,
        480,
        481,
        488,
        489,
        491,
        494,
        504,
        505,
        506,
        507,
        508,
        509,
        510,
        511,
        512,
        513,
        514,
        515,
        545,
        546,
        547,
        548,
        554,
        565,
        566,
        582,
        584,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        384,
        489,
        490,
        75,
        383,
        403,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        442,
        451,
        467,
        477,
        551,
        236,
        537,
        538,
        539,
        540,
        541,
        542,
        543
    )
    // {
    //   hardware: 4,
    //   general: 5,
    //   software: 6,
    //   qa: 24,
    //   internet: 28,
    //   information_security: 30,

// }

export const Experience = {
    NONE: 1,
    L1: 2,
    L2: 3,
    L3: 4,
    L4: 5,
    1: 'NONE',
    2: 'L1',
    3: 'L2',
    4: 'L3',
    5: 'L4'
}

export const HITECH_CATEGORIES_LIST = values(HITECH_CATEGORIES)

export const CATEGORIES = {
    Administration: 1,
    Management: 2,
    Skilled: 3,
    Instruction: 7,
    General: 8,
    Finance: 9,
    Engineering: 10,
    CustomerService: 11,
    Hotels: 12,
    HR: 13,
    Lawyer: 14,
    Media: 15,
    Medical: 16,
    Sales: 17,
    Industry: 18,
    Home: 19,
    Science: 20,
    Logistics: 21,
    Insurance: 23,
    Security: 25,
    Styling: 26,
    Marketing: 27,
    Transportation: 29,
    Tourism: 31,
    Fashion: 32,
    Retail: 33
}

export const NUM_ITEMS_PER_WIZARD_CAROUSEL = 9
export const WIZARD_FORM_FIELDS = [
    'catdir',
    'subcat',
    'experience',
    'city',
    'range'
]
export const WIZARD_MAX_SUBCAT = 6
export const WIZARD_MAX_QUALITIES = 3
export const WIZARD_STATIC_PAGES = {
    CV: 'cv',
    TIPS: 'tips'
}
export const WIZARD_SUCCESS_DELAY = 1500

/**
 * @todo receive items from server (i.e like in SectionTips)
 */
export const WIZARD_STATIC_PAGE_ITEMS = {
    [WIZARD_STATIC_PAGES.CV]: [{
        Link: 'https://www.drushim.co.il/cvwizard/',
        Title: 'לאשף כתיבת קורות חיים מנצחים',
        PreviewImageLink: require('../../../assets/img/wizard_cv.jpg')
    }],
    [WIZARD_STATIC_PAGES.TIPS]: [{
            Link: 'https://www.drushim.co.il/article/12/',
            Title: 'מדריך חיפוש עבודה: 10 צעדים פשוטים למציאת עבודה!',
            PreviewImageLink: 'http:\u002F\u002Fadmin.drushim.co.il\u002FContent\u002FUploads\u002F636660330121209428_4.1.jpg'
        },
        {
            Link: 'https://www.drushim.co.il/article/127/',
            Title: 'מדריך למציאת עבודה ראשונה - ללא ניסיון',
            PreviewImageLink: 'http:\u002F\u002Fadmin.drushim.co.il\u002FContent\u002FUploads\u002F636637859509943900_24.jpg'
        },
        {
            Link: 'https://www.drushim.co.il/article/44/',
            Title: 'מדריך הכנה לראיון עבודה: 12 טיפים להצלחה:',
            PreviewImageLink: 'http:\u002F\u002Fadmin.drushim.co.il\u002FContent\u002FUploads\u002F636905825150718458_93.1.jpg'
        }
    ]
}